export interface NavItem {
  key: 'features' | 'results' | 'cases'
  href?: string
  disabled?: boolean
}

export const navItems: NavItem[] = [
  { key: 'features', disabled: true },
  { key: 'results', href: '#resultats' },
  { key: 'cases', href: '#cas-clients' }
]
